import sourcing from './sourcing'

export default sourcing
